
        var result = require("!!../../../../node_modules/css-loader/index.js!./courseridden-list.component.css");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./ClientApp/app/components/courseridden-list/courseridden-list.component.css
// module id = 586
// module chunks = 0